import { LightningElement, api, wire } from "lwc";
import { LabelsAdapter } from "common/labelsAdapter";
import { createTrack } from "common/track";

var data$7 = { language_select_assistive_text: "Wählen Sie Ihre Sprache aus:" };
data$7.language_select_assistive_text;

var data$6 = { language_select_assistive_text: "Select your language:" };
data$6.language_select_assistive_text;

var data$5 = { language_select_assistive_text: "Seleccione su idioma:" };
data$5.language_select_assistive_text;

var data$4 = { language_select_assistive_text: "Sélectionnez votre langue :" };
data$4.language_select_assistive_text;

var data$3 = { language_select_assistive_text: "言語を選択:" };
data$3.language_select_assistive_text;

var data$2 = { language_select_assistive_text: "언어를 선택하십시오:" };
data$2.language_select_assistive_text;

var data$1 = { language_select_assistive_text: "Selecione um idioma:" };
data$1.language_select_assistive_text;

var data = { language_select_assistive_text: "选择语言：" };
data.language_select_assistive_text;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$7,
  en: data$6,
  esMX: data$5,
  fr: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

class footer extends LightningElement {
  @api content = null;
  @wire(LabelsAdapter, {
    locales,
  })
  labels = null;
  track = createTrack(this);

  get selectedLocale() {
    if (!this.content.locales || !this.content.locales.length) return undefined;
    let locale = this.content.locales.find((locale) => locale.selected);
    return locale ? locale.value : this.content.locales[0].value;
  }

  handleGlobalTrack(e) {
    let eventName = e.detail.eventName;
    this.track(eventName, e.detail.payload);
  }

  handleLinkClick(e) {
    this.dispatchEvent(
      new CustomEvent(e.type, {
        detail: e.detail,
      })
    );
  }

  handleLinksTrack(e) {
    let eventName = e.detail.eventName;
    this.track(eventName, e.detail.payload);
  }

  handleLocaleChange(e) {
    this.dispatchEvent(
      new CustomEvent("locale_change", {
        detail: {
          value: e.detail,
        },
      })
    );
    this.track("language_selector_changed", {
      label: e.detail,
    });
  }
}

export default footer;
